module.exports = __webpack_public_path__ + "media/images/pic/teachers/krzysztof-walaszek-abac8535e87a2a98cbde68e8e67e2c3f.webp";